/************************************
1. If you want to add or remove items you will need to change a variable called $slide-count in the CSS *minimum 3 slides

2. if you want to change the dimensions of the slides you will need to edit the slideWidth variable here 👇 and the $slide-width variable in the CSS.
************************************/

import React from "react";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const options = {
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 2,
    },
    1000: {
      items: 3,
    },
  },
};

const Carousels = () => {
  return (
    <>
      <div>
        {/* <!-- live auctions --> */}
        <section className="mob-section">
          {/* <!-- title --> */}
          {/* <div className="col-12">
            <div className="main__title">
              <h2><a href="#">Latest Chords</a></h2>
            </div>
          </div> */}
          {/* <!-- end title --> */}

          {/* carousel  */}
          <div className="col-12">
            <OwlCarousel
              className="owl-theme hero chords team_members"
              loop
              center={true}
              nav
              id="hero"
              dotsEach={true}
              stagePadding={100}
              {...options}
              style={{ marginTop: "0", paddingTop: "8%", paddingBottom: "8%" }}
            >
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/6.1.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/6.2.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/6.3.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/6.5.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/c1.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/c2.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/c3.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/c4.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
              <div className="item">
                <div className="card auctions_card">
                  <Link to="/home" className="card__cover">
                    <img
                      className="auction_img"
                      src={"images/new/c5.png"}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
            </OwlCarousel>
          </div>
          {/* end carousel  */}
        </section>
        {/* end live auctions */}
      </div>
    </>
  );
};

export default Carousels;
